import { ProviderRegistryApi } from "@asd/customer-portal-api";
// import { AxiosResponse } from "axios";

import AxiosConfigurations, { AxiosConfiguration } from "./AxiosConfiguration";

import { axiosInstance } from ".";

export class RegistryService {
  static instance: RegistryService;
  private registryApi;
  private axiosConfiguration: AxiosConfiguration | undefined;

  constructor() {
    if (RegistryService.instance) {
      return RegistryService.instance;
    }

    this.registryApi = new ProviderRegistryApi(undefined, undefined, axiosInstance);
    const config = AxiosConfigurations.createAxiosConfiguration("registryService", this.registryApi);
    if (!config) {
      throw new Error("Failed to create AxiosConfiguration for registryService");
    }
    this.axiosConfiguration = config;

    RegistryService.instance = this;
  }

  public getPendingRequestCount() {
    return this.axiosConfiguration?.getPendingRequestCount();
  }

  // public async getProviderRegistry(search?: string, page?: number, size?: number, sort?: Array<string>, options: object = {}) {
  //   if (!this.registryApi) {
  //     throw new Error("registryApi is not initialized");
  //   }

  //   try {
  //     const response: AxiosResponse = await this.registryApi.getProviderRegistry(
  //       search?.length ? search : undefined,
  //       page,
  //       size,
  //       sort?.length ? sort : undefined,
  //       options,
  //     );
  //     return response;
  //   } catch {
  //     // do nothing
  //   }
  // }

  // public async exportProviderRegistryCsv(search?: string, sort?: Array<string>, options: object = {}) {
  //   if (!this.registryApi) {
  //     throw new Error("registryApi is not initialized");
  //   }

  //   try {
  //     const response: AxiosResponse = await this.registryApi.exportProviderRegistryCsv(
  //       search?.length ? search : undefined,
  //       sort?.length ? sort : undefined,
  //       options,
  //     );

  //     const link = document.createElement("a");
  //     link.href = window.URL.createObjectURL(new Blob([response.data]));
  //     link.download = "Registry.csv";

  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);

  //     window.URL.revokeObjectURL(link.href);
  //   } catch {
  //     // do nothing
  //   }
  // }
}

export default new RegistryService();
